export default "__VITE_PUBLIC_ASSET__6f2ad69a__"